import api, { ApiResponse } from './api';

export interface LeaveType {
  leaveTypeID: number;
  companyID?: number;
  typeName: string;
  description?: string;
  defaultDays?: number;
  isPaid: boolean;
  requiresApproval: boolean;
  isActive: boolean;
}

const leaveTypesService = {
  list: async (includeInactive: boolean = false): Promise<ApiResponse<LeaveType[]>> => {
    const q = includeInactive ? '?includeInactive=true' : '';
    return api.get(`/leave-types${q}`);
  },

  get: async (id: number): Promise<ApiResponse<LeaveType>> => {
    return api.get(`/leave-types/${id}`);
  },

  create: async (data: Partial<LeaveType>): Promise<ApiResponse<LeaveType>> => {
    return api.post('/leave-types', data);
  },

  update: async (id: number, data: Partial<LeaveType>): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/leave-types/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/leave-types/${id}`);
  },
};

export default leaveTypesService;
